import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'

const useGetReports = ({ id }) => {
  const [reports, setReports] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  const { userToken: token } = useSelector((state) => state.auth)

  useEffect(() => {
    const getReports = async () => {
      if (!id) return
      try {
        setLoading(true)
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}/report_table_brainscan`, {
          method: 'POST',
          headers: { Authorization: `Bearer ${token}` },
          body: JSON.stringify({ user_id: id, test_area: 'one' }),
        })
        if (!response.ok) {
          throw new Error('Network response was not ok')
        }
        const data = await response.json()
        setReports(data.brain_scan_report)
      } catch (error) {
        const message = (error.data && error.data.error) || error.message
        setError(message)
      } finally {
        setLoading(false)
      }
    }

    getReports()
  }, [id, token])

  return { reports, loading, error }
}

export default useGetReports
